import { getImageFromS3 } from '../imageService';

export const twoSpecialCapsuleChallenge = [
  {
    id: '1',
    title: 'Хто з них більше нагадує тобі себе?',
    imageList: [
      {
        id: '1',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/1.1.png'
        )
      },
      {
        id: '2',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/1.2.png'
        )
      }
    ]
  },
  {
    id: '2',
    title: 'Де тобі найкраще відпочити на вихідних?',
    imageList: [
      {
        id: '1',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/2.1.png'
        )
      },
      {
        id: '2',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/2.2.png'
        )
      }
    ]
  },
  {
    id: '3',
    title: 'Який з цих десертів для тебе найапетитніший?',
    imageList: [
      {
        id: '1',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/3.1.png'
        )
      },
      {
        id: '2',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/3.2.png'
        )
      }
    ]
  },
  {
    id: '4',
    title: 'Чим зап’єш десерт?',
    imageList: [
      {
        id: '1',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/4.1.png'
        )
      },
      {
        id: '2',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/4.2.png'
        )
      }
    ]
  },
  {
    id: '5',
    title: 'Де тобі буде затишніше подрімати?',
    imageList: [
      {
        id: '1',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/5.1.png'
        )
      },
      {
        id: '2',
        url: getImageFromS3(
          '/images/special-capsules/two-image-challenge/5.2.png'
        )
      }
    ]
  }
];

export const twoSpecialCapsuleResultList = [
  {
    resultId: '1',
    title: 'Лісові ягоди',
    image: getImageFromS3(
      '/images/special-capsules/two-image-challenge/forest-berries.png'
    )
  },
  {
    resultId: '2',
    title: 'Кавун',
    image: getImageFromS3(
      '/images/special-capsules/two-image-challenge/watermelon.png'
    )
  }
];

export const yourTopSpecialCapsuleChallenge = [
  {
    id: '1',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/1.png'),
    text: 'Вироби з діамантів'
  },
  {
    id: '2',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/2.png'),
    text: 'Персональний басейн'
  },
  {
    id: '3',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/3.png'),
    text: 'Приватні літаки'
  },
  {
    id: '4',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/4.png'),
    text: 'Яхти'
  },
  {
    id: '5',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/5.png'),
    text: 'Спорткари'
  },
  {
    id: '6',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/6.png'),
    text: 'Екзотична відпустка'
  },
  {
    id: '7',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/7.png'),
    text: 'Трюфелі'
  },
  {
    id: '8',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/8.png'),
    text: 'Устриці'
  },
  {
    id: '9',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/9.png'),
    text: 'Власний острів'
  },
  {
    id: '10',
    url: getImageFromS3('/images/special-capsules/your-top-challenge/10.png'),
    text: 'Дорогі годинники'
  }
];
